import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { About } from "./components/about";
import { Contact } from "./components/contact";
import ScrollToTop from "./components/ScrollToTop";
import SplashScreen from "./Componentes/SplashScreen"; 
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import Portada1 from "./Componentes/Portada1";
// import Portada2 from "./Componentes/Portada2";
// import Prueba from "./Componentes/prueba";
import Encuesta from "./Componentes/Encuesta";
import MapComponent from "./Componentes/MapComponent";
import TeamPage from "./Componentes/TeamPage";
import PublicacionesPage from "./Componentes/PublicacionesPage";
import { Blog } from "./components/blog";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

// Página principal (landing)
const HomePage = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const [showSplash, setShowSplash] = useState(true);
  const [visitas, setVisitas] = useState(0);

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  useEffect(() => {
    fetch("http://TU_IP_O_DOMINIO:4002/api/visits")
      .then((res) => res.json())
      .then((data) => setVisitas(data.visits))
      .catch((err) => console.error(err));
  }, []);

  const navigate = useNavigate();

  const handleCloseSplash = () => setShowSplash(false);
  const handleSurvey = () => navigate("/encuesta");

  return (
    <>
      <Header />
      <Navigation />
      <Portada1 />
      <p style={{ textAlign: "center", fontSize: "14px", marginTop: "10px" }}>
        Visitas totales: {visitas}
      </p>
      <About data={landingPageData.About} />
      <Contact data={landingPageData.Contact} />

      {showSplash && (
        <SplashScreen
          onClose={handleCloseSplash}
          onSurvey={handleSurvey}
        />
      )}
    </>
  );
};


const BlogPage = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);
  return (
    <>
      <Header />
      <Navigation />
      <Blog />
      <Contact data={landingPageData.Contact} />
    </>
  );
};

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<HomePage />} />
    <Route path="/encuesta" element={<Encuesta />} />
    <Route path="/metrominuto" element={<MapComponent />} />
    <Route path="/team" element={<TeamPage />} />
    <Route path="/services" element={<PublicacionesPage />} />
    <Route path="/blog" element={<BlogPage />} />
  </Routes>
);

const App = () => (
  <Router>
    <ScrollToTop />
    <AppRoutes />
  </Router>
);

export default App;
